import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Context } from '../context/Contex';


function PrivateRoute({ children }) {
  const { authenticated, loading } = useContext(Context);

  if (loading) {
    return <div>Carregando...</div>;
  }

  return authenticated ? children : <Navigate to="/login" />;
}

export default PrivateRoute;